const getters = {
  totalProducts: (state) => state.products,
};
export default getters;
